
export default {

  userToken: '',
  tokenRemaining: 0,

  userInfo: {},
  companyInfo: {},
  myInfo: {},

  rememberedEmail : '',           // 로그인할 때 저장된 이메일 주소
  isEmailRemember : false,    // 로그인 할 때 이메일 주소를 저장할지 여부
  ipInfo : {},

  qrCodeContent:'',
  isScanner: false
}
